import { Button, ClockIcon, Typography } from '@eventbrite/marmalade';
import React, { useEffect, useRef } from 'react';
import styles from './OperatingHoursModal.module.scss';

export interface OperatingHoursModalProps {
    isShown: boolean;
    openings: Array<string>;
    handleClose: () => void;
}

const ModalHeader: React.FC<{}> = () => {
    return (
        <div className={styles.modalHeader}>
            <ClockIcon size="large" />
            <Typography
                align="center"
                as="h2"
                color="neutral-1000"
                variant="heading-sm"
            >
                Operating hours
            </Typography>
        </div>
    );
};

export const OperatingHoursModal: React.FC<OperatingHoursModalProps> = (
    props,
) => {
    const { isShown, openings, handleClose } = props;
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (isShown) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }
    }, [isShown, dialogRef.current?.open]);

    const handleClickAway = (event: React.MouseEvent<HTMLDialogElement>) => {
        const modalArea = event.currentTarget.getBoundingClientRect();
        const clickedIn =
            modalArea.top <= event.clientY &&
            event.clientY <= modalArea.top + modalArea.height &&
            modalArea.left <= event.clientX &&
            event.clientX <= modalArea.left + modalArea.width;

        if (!clickedIn) {
            handleClose();
        }
    };

    return (
        <dialog
            ref={dialogRef}
            className={styles.dialog}
            onClick={handleClickAway}
        >
            <div className="click-away-detector">
                <ModalHeader />
                <div className={styles.modalBody}>
                    <div className={styles.openings}>
                        {openings.map((opening) => {
                            // String format: 'Monday: 9:00 AM – 5:00 PM'
                            const [dayOfWeek, openHours] = opening.split(': ')

                            return (
                                <div
                                    className={styles.openingLine}
                                    key={`${dayOfWeek}-openingLine`}
                                >
                                    <Typography
                                        align="left"
                                        as="p"
                                        color="neutral-800"
                                        variant="body-md"
                                        key={dayOfWeek}
                                    >
                                        {dayOfWeek}
                                    </Typography>
                                    <Typography
                                        className={styles.openHours}
                                        align="right"
                                        as="p"
                                        color="neutral-800"
                                        variant="body-md"
                                        key={`${dayOfWeek}-openHours`}
                                    >
                                        {openHours}
                                    </Typography>
                                </div>
                            );
                        })}
                    </div>
                    <Button
                        className={styles.dismissButton}
                        aria-label="dismiss button"
                        variant="ghost"
                        onClick={handleClose}
                    >
                        {' '}
                        Dismiss{' '}
                    </Button>
                </div>
            </div>
        </dialog>
    );
};
